import { useMemo } from 'react'
import { ScheduleType } from 'types/schedule'
import { StockUnionType } from 'types/stock'

const useSchedulesOfType = (schedules: ScheduleType[], type: StockUnionType): ScheduleType[] => {
  return useMemo(() => {
    return schedules.filter((schedule) => schedule.type === type)
  }, [schedules])
}

export default useSchedulesOfType
